module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NPeevk/tc-custom/9798889101611.jpg?1718106101436",
      "alt": "This image is the cover for the book You Are Beautiful"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("You Are Beautiful\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Aptos\",sans-serif",
      "text-align": "center"
    }
  }, [_c('em', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("You Are Beautiful")])]), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v(" is a contemporary children’s book that celebrates children’s differences. ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Aptos\",sans-serif",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("This is a book that any child can pick up to read and feeling good about themselves and their friends.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Aptos\",sans-serif",
      "text-align": "center"
    }
  }, [_c('em', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("You Are Beautiful")])]), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v(" is a representation of many children, including those with special needs. ")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Aptos\",sans-serif",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("This book highlights differences, teaches kindness, understanding and reminds us all that we are beautiful just the way we are.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ashley E. Kettering\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Ashley E. Kettering currently resides in Illinois but was born and raised in Sheboygan, Wisconsin. She is married and has a beautiful daughter and twin boys. She loves animals and has two dogs and a sassy cat. She is a high school English teacher. She graduated with honors from the University of Wisconsin-Oshkosh. She and her family enjoy traveling, swimming, and trying different foods. Mrs. Kettering is an avid reader and enjoys spending her summers at Elkhart Lake with her family and friends.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0